const clientThemes = {
  kredova: {
    key: 'kredova',
    brandName: 'KREDOVA',
    cssVariables: {
      '--client-primary': '#0f487d',
      '--sidebar-bg-hover': 'rgba(18, 120, 252, 0.1)',
      '--sidebar-text-hover-color': '#0f487d',
      '--dashboard-accent-bg':
        'linear-gradient(135deg, #090358 0%, #090358 14.286%, #090358 calc(14.286% + 1px), #090358 28.571%, #090358 calc(28.571% + 1px), #090358 42.857%, #130b82 calc(42.857% + 1px), #20179e 57.143%, #26379e calc(57.143% + 1px), #2436a2 71.429%, #1a39c0 calc(71.429% + 1px), #1a39c0 85.714%, #113ccc 100%)',
      '--client-logo-padding': '11.5px 5px',
      '--client-sidebar-logo-padding': '16px 8px 4px',
      '--client-compact-logo-padding': '8px 2px 0',
      '--client-logo-text-align': 'left',
    },
    logoWidth: {
      collapsed: 25,
      expanded: 145,
    },
    assets: {
      favicon: '/kredova/favicon.ico',
      dashboardLogo: '/kredova/KREDOVA_horizontal_white.svg',
      collapsedLogo: '/kredova/n5.svg',
      loginLogo: '/kredova/KREDOVA_Horizontal_blue.svg',
      surveyLogo: '/kredova/KREDOVA_Horizontal_blue.svg',
      loader: '/kredova/kredova_loader.svg',
      loginBackground: '/kredova/sign_in_bg.jpg',
      loginShowcaseLogo: '/kredova/KREDOVA_Horizontal_blue.svg',
      loginCardBackground: '/kredova/signin_page_bg.jpg',
    },
    footer: {
      copyright: 'Kredova Solutions Private Limited',
      designedBy: 'Kredova',
    },
  },
  ndia5: {
    key: 'ndia5',
    brandName: 'NDIA5',
    cssVariables: {
      '--client-primary': '#0f487d',
      '--sidebar-bg-hover': 'rgba(18, 120, 252, 0.1)',
      '--sidebar-text-hover-color': '#0f487d',
      '--dashboard-accent-bg':
        'linear-gradient(135deg, #090358 0%, #090358 14.286%, #090358 calc(14.286% + 1px), #090358 28.571%, #090358 calc(28.571% + 1px), #090358 42.857%, #130b82 calc(42.857% + 1px), #20179e 57.143%, #26379e calc(57.143% + 1px), #2436a2 71.429%, #1a39c0 calc(71.429% + 1px), #1a39c0 85.714%, #113ccc 100%)',
      '--client-logo-padding': '11.5px 5px',
      '--client-sidebar-logo-padding': '16px 8px 4px',
      '--client-compact-logo-padding': '8px 2px 0',
      '--client-logo-text-align': 'left',
    },
    logoWidth: {
      collapsed: 55,
      expanded: 115,
    },
    assets: {
      favicon: '/ndia5/favicon.ico',
      dashboardLogo: '/ndia5/ndia5_logo.png',
      collapsedLogo: '/ndia5/n5.svg',
      loginLogo: '/ndia5/ndia5_logo_2.svg',
      surveyLogo: '/ndia5/ndia5_logo_2.svg',
      loader: '/ndia5/ndia5_loader.svg',
      loginBackground: '/ndia5/sign_in_bg.jpg',
      loginShowcaseLogo: '/ndia5/ndia5_logo_white.svg',
    },
    footer: {
      copyright: 'Kredova Solutions Private Limited',
      designedBy: 'Kredova',
    },
  },
  jcpl: {
    key: 'jcpl',
    brandName: 'Junoon',
    cssVariables: {
      '--client-primary': '#E93794',
      '--client-primary-text': '#FFFFFF',
      '--client-primary-disabled': '#FFD6E7',
      '--client-primary-disabled-text': '#E93794',
      '--sidebar-bg-hover': '#FDEBF4',
      '--sidebar-text-hover-color': '#E93794',
      '--dashboard-accent-bg':
        'linear-gradient(135deg, #770833 0%, #770833 7.692%, #8a1543 calc(7.692% + 1px), #8a1543 15.385%, #9b2353 calc(15.385% + 1px), #9b2353 23.077%, #ab3264 calc(23.077% + 1px), #ab3264 30.769%, #ba4175 calc(30.769% + 1px), #ba4175 38.462%, #c75085 calc(38.462% + 1px), #c75085 46.154%, #d36096 calc(46.154% + 1px), #d36096 53.846%, #dd70a6 calc(53.846% + 1px), #dd70a6 61.538%, #e680b6 calc(61.538% + 1px), #e680b6 69.231%, #ed90c5 calc(69.231% + 1px), #ed90c5 76.923%, #f39fd3 calc(76.923% + 1px), #f39fd3 84.615%, #f7aee1 calc(84.615% + 1px), #f7aee1 92.308%, #fabded 100%)',
      '--dashboard-accent-btn-bg': 'linear-gradient(135deg, #770833 0%, #c75085 55%, #e680b6 100%)',
      '--client-logo-padding': '11.5px 0',
      '--client-sidebar-logo-padding': '16px 0 4px',
      '--client-compact-logo-padding': '8px 0 0',
      '--client-logo-text-align': 'left',
      '--login-form-shadow': '0px 50px 50px rgba(147, 4, 80, 0.4)',
    },
    logoWidth: {
      collapsed: 55,
      expanded: 200,
    },
    assets: {
      favicon: '/jcpl/favicon.ico',
      dashboardLogo: '/jcpl/junoon_white_logo.png',
      collapsedLogo: '/jcpl/junoon_white_logo_icon.png',
      loginLogo: '/jcpl/junoon_logo.png',
      surveyLogo: '/jcpl/junoon_logo.png',
      loader: '/jcpl/junoon_loader.svg',
      loginBackground: '/jcpl/sign_in_bg.jpg',
      loginShowcaseLogo: '/jcpl/junoon_logo.svg',
      loginCardBackground: '/jcpl/signin_page_bg.jpg',
    },
    footer: {
      copyright: 'Junoon Capital Services Private Limited',
      designedBy: 'Kredova',
    },
  },
};

const requestedTheme = (
  process.env.NEXT_PUBLIC_CLIENT_THEME || 'kredova'
).trim().toLowerCase();

if (!Object.prototype.hasOwnProperty.call(clientThemes, requestedTheme)) {
  throw new Error(
    `Unsupported NEXT_PUBLIC_CLIENT_THEME "${requestedTheme}". Supported themes: ${Object.keys(clientThemes).join(', ')}.`
  );
}

export const clientTheme = clientThemes[requestedTheme];
